import { useContext } from 'react'

import { MODALS_ID } from '../../../constants'

import { toast } from '../../../utils'

import { StoresContext } from '../../../provider/StoreProvider'
import { ModalContext } from '../../../provider/modalProvider'

import { useNavigate } from '../../../hooks/useNavigate'

import { Button } from '../../../components/button'
import { Modal } from '../../../components/modal'
import { Text } from '../../../components/text'

export function LogoutModal() {
  const { authStore } = useContext(StoresContext)
  const { closeModal } = useContext(ModalContext)

  const navigate = useNavigate()

  const close = () => closeModal(MODALS_ID.LOGOUT)

  const logout = async () => {
    try {
      navigate('/home')
      await authStore.signOut()
      close()
    } catch (err) {
      toast('로그아웃에 실패했습니다.', err)
    }
  }

  return (
    <Modal id={MODALS_ID.LOGOUT}>
      <Text size={16} weight={500} lineHeight={24} $textAlign="center">
        로그아웃 하시겠어요?
      </Text>
      <Modal.Footer>
        <Button onClick={close}>취소</Button>
        <Button type="primary" onClick={logout}>
          네
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
